import { render, staticRenderFns } from "./goal-gift.vue?vue&type=template&id=76ece046&"
import script from "./goal-gift.vue?vue&type=script&lang=js&"
export * from "./goal-gift.vue?vue&type=script&lang=js&"
import style0 from "./goal-gift.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GiftReceiverHeader: require('/home/runner/work/webpage/webpage/components/gift-receiver/header/header.vue').default,GiftReceiverTestPlans: require('/home/runner/work/webpage/webpage/components/gift-receiver/test-plans/test-plans.vue').default,GiftReceiverHowItWorks: require('/home/runner/work/webpage/webpage/components/gift-receiver/how-it-works/how-it-works.vue').default,AreaKeyPoints: require('/home/runner/work/webpage/webpage/components/area/key-points/key-points.vue').default,BaseTestimonialsVideo: require('/home/runner/work/webpage/webpage/components/base/testimonials-video/testimonials-video.vue').default,AreaFaqs: require('/home/runner/work/webpage/webpage/components/area/faqs/faqs.vue').default})
